import { DataCache } from "./data.cache";
import { DataService } from "../../service/data/data.service";
import { Cast } from "@xanadu/model";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class CastCache extends DataCache<Cast> {

    constructor(
        dataService: DataService
    ) {
        super(Cast, dataService);
    }
}
